import { render, staticRenderFns } from "./EmergencyHistoryTable.vue?vue&type=template&id=bbb2efda&scoped=true"
import script from "./EmergencyHistoryTable.vue?vue&type=script&lang=js"
export * from "./EmergencyHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./EmergencyHistoryTable.vue?vue&type=style&index=0&id=bbb2efda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb2efda",
  null
  
)

export default component.exports